/* src/app/shared-module/components/profile-image/profile-image.component.scss */
.drop-zone {
  background-color: #f6f6f6;
  border: dotted 3px #dedddd;
  height: 30vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}
.file-input-container {
  text-align: right;
  color: white;
}
.file-input-container input[type=file] {
  display: none;
}
.file-input-container label {
  border: 1px solid #ccc;
  padding: 6px 12px;
  cursor: pointer;
}
.nv-file-over {
  border: dotted 3px red;
}
ion-list {
  background-color: transparent;
}
ion-item {
  --background: transparent;
}
/*# sourceMappingURL=profile-image.component.css.map */
